import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { Store } from "@ngxs/store";
// Modules
import { ModalSize, ObjectUtils, SystemApiService } from "@cv-invision/core";
// Models
import { DeliveryAssetsConfigModel } from "./model/delivery-assets.model";
import { IntegrationsUrlParamsModel } from "../generic-integrations/models/integrations-url-params.model";
import { IdNameObjectType } from "../state/models/global-configuration-state.model";
// State
import { GlobalConfigurationEnumsState } from "../state/global-configuration-enums.state";
// Services
import { DeliveryAssetsService } from "./service/delivery-assets.service";

@Component({
	selector: 'cv-delivery-assets',
	styleUrls: ['./delivery-assets.component.scss'],
	templateUrl: './delivery-assets.component.html',
})
export class DeliveryAssetsComponent implements OnInit, OnDestroy {
	label = 'Delivery Assets'
	modalSize = ModalSize.LG;
	extraData: any;
	model: any;
	deliveryAssetsParams: IntegrationsUrlParamsModel;

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private store: Store,
		private deliveryAssetsService: DeliveryAssetsService,
		private systemApiService: SystemApiService
	) {

	}

	async ngOnInit(): Promise<void> {
		this.extraData = {
			editInModal: true,
			isExternalIntegration: true,
			showSelect: false,
			saveAsObject: true,
			deliveryAssets: {}
		};

		this.model = DeliveryAssetsConfigModel;

		this.deliveryAssetsParams = new IntegrationsUrlParamsModel();
		this.deliveryAssetsParams.isExternalIntegration = true;
		this.deliveryAssetsParams.customUrl = 'products/deliveryAssets';
		this.deliveryAssetsParams.customSaveUrl = 'products/deliveryAsset';
		this.deliveryAssetsParams.modalCustomClass = 'delivery-assets-modal'
		await this.loadStoreData();

	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	loadStoreData(): Promise<void> {
		const trackingSystemList: Array<IdNameObjectType> = this.store.selectSnapshot(GlobalConfigurationEnumsState.getTrackingSystems);

		if (trackingSystemList.length > 0) {
			this.model['formBuilderConfig']['eventSource']['options'] = trackingSystemList?.map((item: IdNameObjectType) => {
				return {
					label: item.name,
					value: item.id,
				};
			});

			const deliveryAssetsTrackingSystemList = ObjectUtils.recursiveDeepCopy(trackingSystemList);
			deliveryAssetsTrackingSystemList.push({name: 'Class', id: 'Class'});
			this.model['formBuilderConfig']['deliveryAssets']['childFormBuilderConfig']['source']['options'] = deliveryAssetsTrackingSystemList?.map((item: any) => {
				return {
					label: item.name,
					value: item.id,
				};
			})

			deliveryAssetsTrackingSystemList.forEach((trackingSystem: IdNameObjectType) => {
				const trackingSystemStoreName = trackingSystem.id === 'Class' ? 'classValuation' : trackingSystem.id[0].toLowerCase() + trackingSystem.id.substring(1);

				const documentTypesList = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, `globalConfiguration.deliveryAssets.${trackingSystemStoreName}.documentTypes`));

				const documentTypesOptions = documentTypesList.map((item: IdNameObjectType) => {
					return {
						label: item.name,
						value: item.id,
					};
				});

				const documentTypesData = {};
				documentTypesData[trackingSystem.id.toLowerCase()] = documentTypesOptions;

				this.extraData.deliveryAssets = Object.assign(this.extraData.deliveryAssets, documentTypesData);
			})

			trackingSystemList.forEach((trackingSystem: IdNameObjectType) => {
				const trackingSystemStoreName = trackingSystem.id[0].toLowerCase() + trackingSystem.id.substring(1);
				const productsList = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, `globalConfiguration.${trackingSystemStoreName}.products`));

				const productOptions = productsList.map((item: any) => {
					return {
						label: item.title,
						value: item.id,
					};
				});

				const productsData = {}
				productsData[trackingSystemStoreName] = productOptions;

				this.extraData = Object.assign(this.extraData, productsData);
			})
		}

		this.extraData.rootUrl = this.systemApiService.api.orders;

		// we have to add into the loader & save in the store
		this.deliveryAssetsService.getIntegrations().subscribe(response => {
			const providerOptions = response.map((item: any) => {
				return {
					label: item,
					value: item,
				};
			});
			this.model['formBuilderConfig']['provider']['options'] = providerOptions;
		});

		return new Promise((resolve, reject) => {
			resolve();
		})
	}
}
